import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/fonts/fonts.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './theme/variables.css';
import './theme/global.css';
import App from './App';
import {
  GlobalErrorBoundary,
  initializeGlobalErrorLogging,
} from './bootstrap/globalErrorLogging';

initializeGlobalErrorLogging();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </React.StrictMode>
);
